// extracted by mini-css-extract-plugin
module.exports = {"content":"betSuccessContainer_content__vINWj"};